import { useEffect, useState } from "react";
import "./Testimonials.css";
import API_BASE_URL from "../config/config";

function Testimonials() {

    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [currentSlide, setCurrentSlide] = useState(0);

    // =========================================================
    // API URL
    // =========================================================

    const API_URL = API_BASE_URL.replace(/\/$/, "");

    const STORAGE_BASE_URL = API_URL.replace(/\/api$/, "");

    const STORAGE_URL =
        `${STORAGE_BASE_URL}/storage/testimonial`;


    // =========================================================
    // FETCH TESTIMONIALS
    // =========================================================

    useEffect(() => {

        const fetchTestimonials = async () => {

            try {

                setLoading(true);
                setError("");

                const response = await fetch(
                    `${API_URL}/user-testimonials`,
                    {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        },
                    }
                );

                const text = await response.text();

                console.log(
                    "Testimonials API URL:",
                    `${API_URL}/user-testimonials`
                );

                console.log(
                    "Testimonials API Status:",
                    response.status
                );

                console.log(
                    "Testimonials API Response:",
                    text
                );


                let data;

                try {

                    data = JSON.parse(text);

                } catch (jsonError) {

                    throw new Error(
                        `Server returned invalid JSON. HTTP Status: ${response.status}`
                    );

                }


                if (!response.ok) {

                    throw new Error(
                        data.message ||
                        `Failed to fetch testimonials (${response.status})`
                    );

                }


                // =====================================================
                // RESPONSE DATA
                // =====================================================

                if (Array.isArray(data)) {

                    setTestimonials(data);

                } else if (Array.isArray(data.testimonials)) {

                    setTestimonials(data.testimonials);

                } else if (Array.isArray(data.data)) {

                    setTestimonials(data.data);

                } else {

                    setTestimonials([]);

                    setError(
                        data.message ||
                        "No testimonials available."
                    );

                }

            } catch (error) {

                console.error(
                    "Testimonials API Error:",
                    error
                );

                setError(
                    error.message ||
                    "Unable to load testimonials."
                );

                setTestimonials([]);

            } finally {

                setLoading(false);

            }

        };


        fetchTestimonials();

    }, [API_URL]);


    // =========================================================
    // AUTO SLIDE
    // =========================================================

    useEffect(() => {

        if (testimonials.length <= 1) {
            return;
        }

        const interval = setInterval(() => {

            setCurrentSlide((prev) => {

                if (prev >= testimonials.length - 1) {
                    return 0;
                }

                return prev + 1;

            });

        }, 5000);


        return () => {
            clearInterval(interval);
        };

    }, [testimonials.length]);


    // =========================================================
    // PREVIOUS
    // =========================================================

    const handlePrevious = () => {

        setCurrentSlide((prev) => {

            if (prev <= 0) {
                return testimonials.length - 1;
            }

            return prev - 1;

        });

    };


    // =========================================================
    // NEXT
    // =========================================================

    const handleNext = () => {

        setCurrentSlide((prev) => {

            if (prev >= testimonials.length - 1) {
                return 0;
            }

            return prev + 1;

        });

    };


    // =========================================================
    // DOT CLICK
    // =========================================================

    const handleDotClick = (index) => {

        setCurrentSlide(index);

    };


    // =========================================================
    // LOADING
    // =========================================================

    if (loading) {

        return (

            <section className="testimonials-section">

                <div className="testimonials-container">

                    <div className="testimonials-heading">

                        <span className="testimonial-badge">
                            TESTIMONIALS
                        </span>

                        <h2 className="testimonial-title">

                            What{" "}

                            <strong>
                                Doctors Say
                            </strong>

                        </h2>

                        <p className="testimonial-subtitle">
                            Stories of success from our students
                            and happy users
                        </p>

                    </div>


                    <div className="testimonial-loading">

                        <div className="testimonial-spinner"></div>

                        <span>
                            Loading testimonials...
                        </span>

                    </div>

                </div>

            </section>

        );

    }


    // =========================================================
    // ERROR
    // =========================================================

    if (error) {

        return (

            <section className="testimonials-section">

                <div className="testimonials-container">

                    <div className="testimonials-heading">

                        <span className="testimonial-badge">
                            TESTIMONIALS
                        </span>

                        <h2 className="testimonial-title">

                            What{" "}

                            <strong>
                                Doctors Say
                            </strong>

                        </h2>

                    </div>


                    <div className="testimonial-error">
                        {error}
                    </div>

                </div>

            </section>

        );

    }


    // =========================================================
    // NO TESTIMONIALS
    // =========================================================

    if (testimonials.length === 0) {
        return null;
    }


    // =========================================================
    // MAIN UI
    // =========================================================

    return (

        <section className="testimonials-section">

            <div className="testimonials-container">


                {/* =================================================
                    HEADING
                ================================================= */}

                <div className="testimonials-heading">

                    <span className="testimonial-badge">
                        TESTIMONIALS
                    </span>


                    <h2 className="testimonial-title">

                        What{" "}

                        <strong>
                            Doctors Say
                        </strong>

                    </h2>


                    <p className="testimonial-subtitle">

                        Stories of Success of our
                        students / Happy Users

                    </p>

                </div>


                {/* =================================================
                    SLIDER
                ================================================= */}

                <div className="testimonial-slider-wrapper">


                    {/* PREVIOUS BUTTON */}

                    {testimonials.length > 1 && (

                        <button
                            type="button"
                            className="testimonial-slider-btn testimonial-prev"
                            onClick={handlePrevious}
                            aria-label="Previous testimonial"
                        >
                            &#10094;
                        </button>

                    )}


                    {/* SLIDER */}

                    <div className="testimonials-slider">

                        <div
                            className="testimonials-track"
                            style={{
                                transform:
                                    `translateX(-${currentSlide * 100}%)`
                            }}
                        >

                            {testimonials.map(
                                (testimonial, index) => (

                                    <div
                                        className="testimonial-slide"
                                        key={
                                            testimonial.id ||
                                            testimonial.testimonial_id ||
                                            index
                                        }
                                    >

                                        <article className="testimonial-card">


                                            {/* IMAGE */}

                                            <div className="testimonial-avatar-wrapper">

                                                <div className="testimonial-avatar">

                                                    {testimonial.image ? (

                                                        <img
                                                            src={
                                                                testimonial.image.startsWith(
                                                                    "http"
                                                                )
                                                                    ? testimonial.image
                                                                    : `${STORAGE_URL}/${testimonial.image}`
                                                            }
                                                            alt={
                                                                testimonial.title ||
                                                                "Doctor"
                                                            }
                                                            onError={(e) => {

                                                                e.currentTarget.style.display =
                                                                    "none";

                                                            }}
                                                        />

                                                    ) : (

                                                        <div className="testimonial-avatar-placeholder">

                                                            👨‍⚕️

                                                        </div>

                                                    )}

                                                </div>

                                            </div>


                                            {/* QUOTE */}

                                            <div className="testimonial-quote">

                                                <span className="quote-mark">
                                                    “
                                                </span>


                                                <div
                                                    className="testimonial-description"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            testimonial.description ||
                                                            "",
                                                    }}
                                                />


                                                <span className="quote-mark quote-mark-end">
                                                    ”
                                                </span>

                                            </div>


                                            {/* NAME */}

                                            <h3 className="testimonial-name">

                                                {testimonial.title ||
                                                    "Anonymous"}

                                            </h3>


                                            {/* DESIGNATION */}

                                            {testimonial.designation && (

                                                <div className="testimonial-designation">

                                                    {testimonial.designation}

                                                </div>

                                            )}

                                        </article>

                                    </div>

                                )
                            )}

                        </div>

                    </div>


                    {/* NEXT BUTTON */}

                    {testimonials.length > 1 && (

                        <button
                            type="button"
                            className="testimonial-slider-btn testimonial-next"
                            onClick={handleNext}
                            aria-label="Next testimonial"
                        >
                            &#10095;
                        </button>

                    )}

                </div>


                {/* =================================================
                    DOTS
                ================================================= */}

                {testimonials.length > 1 && (

                    <div className="testimonial-dots">

                        {testimonials.map(
                            (testimonial, index) => (

                                <button
                                    type="button"
                                    key={
                                        testimonial.id ||
                                        testimonial.testimonial_id ||
                                        index
                                    }
                                    className={
                                        `testimonial-dot ${
                                            currentSlide === index
                                                ? "active"
                                                : ""
                                        }`
                                    }
                                    onClick={() =>
                                        handleDotClick(index)
                                    }
                                    aria-label={
                                        `Go to testimonial ${index + 1}`
                                    }
                                />

                            )
                        )}

                    </div>

                )}

            </div>

        </section>

    );

}

export default Testimonials;